
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/partnership-program",
      function () {
        return require("private-next-pages/partnership-program/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/partnership-program"])
      });
    }
  